import { ApprovedVendorAllocation } from 'types';

/** Human-readable labels for the AVL allocation values (no label map exists in `types`). */
export const ApprovedVendorAllocationLabels: Record<ApprovedVendorAllocation, string> = {
  [ApprovedVendorAllocation.full]: 'Full',
  [ApprovedVendorAllocation.limited]: 'Limited',
  [ApprovedVendorAllocation.exception]: 'Exception',
  [ApprovedVendorAllocation.preApproval]: 'Pre-Approval',
  [ApprovedVendorAllocation.safeHarbor]: 'Safe Harbor',
  [ApprovedVendorAllocation.deprecated]: 'Deprecated',
};

/**
 * PalmettoTag `color` for each allocation. The DSM tag palette has no blue/teal, so we map to the
 * closest semantic hues: full=green, deprecated=red, limited=amber, exception=orange (palmetto),
 * safeHarbor=purple (volt), preApproval=neutral grey (a pending state).
 */
export type AllocationTagColor = 'grey' | 'palmetto' | 'volt' | 'error' | 'warning' | 'success';

export const ApprovedVendorAllocationTagColors: Record<ApprovedVendorAllocation, AllocationTagColor> = {
  [ApprovedVendorAllocation.full]: 'success',
  [ApprovedVendorAllocation.limited]: 'warning',
  [ApprovedVendorAllocation.exception]: 'palmetto',
  [ApprovedVendorAllocation.preApproval]: 'grey',
  [ApprovedVendorAllocation.safeHarbor]: 'volt',
  [ApprovedVendorAllocation.deprecated]: 'error',
};
